import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases, fa } from 'vuetify/iconsets/fa-svg';
import { library } from '@fortawesome/fontawesome-svg-core';

// Existing imports
import {
    faCheckSquare,
    faChevronLeft,
    faChevronRight,
    faCircle,
    faSquare,
    faSquareMinus,
    faTimes,
    faUpload,
    faChevronDown,
    faPlugCircleBolt,
    faUsbDrive,
    faPlug,
    faBookOpen,
    faIdCard,
    faTshirt,
    faBolt,
    faScrewdriverWrench,
    faTags,
    faSuitcase,
    faHeadphones,
    faBlanket,
    faShoppingCart,
    faTruckFast,
    faEnvelope,
    faHouse,
    faPrint,
    faCircleExclamation,
    faCircleUser,
    faSignInAlt,
    faSignOutAlt
} from '@fortawesome/pro-light-svg-icons';

import {
    faCaretDown,
    faDotCircle,
    faUserMusic,
    faTrashCan,
    faCirclePlus,
    faCircleMinus,
    faCheck,
    faCheckCircle,
    faArrowLeft,
    faArrowRight,
    faLockKeyhole,
    faCircleInfo,
    faExclamationCircle,


    faChevronDown as faChevronDownSolid,
    faChevronLeft as  faChevronLeftSolid,
    faChevronRight as  faChevronRightSolid
} from '@fortawesome/pro-solid-svg-icons';

import {
    faUsps,
    faFedex,
    faUps,
    faDhl
} from '@fortawesome/free-brands-svg-icons';


// Add the icons to the FontAwesome library
library.add(
    // Existing
    faCheckSquare,
    faChevronLeft,
    faChevronRight,
    faChevronDown,
    faCircle,
    faSquare,
    faSquareMinus,
    faTimes,
    faUpload,
    faCaretDown,
    faDotCircle,
    faUserMusic,
    faTrashCan,
    faCirclePlus,
    faCircleMinus,
    faCheck,
    faCheckCircle,
    faArrowLeft,
    faArrowRight,
    faLockKeyhole,
    faCircleInfo,
    faExclamationCircle,
    faCircleExclamation,
    faChevronDownSolid,
    faChevronLeftSolid,
    faChevronRightSolid,


    // New
    faPlug,
    faUsbDrive,
    faBookOpen,
    faIdCard,
    faTshirt,
    faBolt,
    faScrewdriverWrench,
    faTags,
    faSuitcase,
    faHeadphones,
    faPlugCircleBolt,
    faBlanket,
    faShoppingCart,
    faUsps,
    faFedex,
    faUps,
    faDhl,
    faTruckFast,
    faEnvelope,
    faHouse,
    faPrint,
    faCircleUser,
    faSignInAlt,
    faSignOutAlt
);

const customAliases = {
    ...aliases,
    cancel: 'fas fa-times',
    clear: 'fas fa-times',
    close: 'fas fa-times',
    delete: 'fas fa-times',
    checkboxIndeterminate: 'fal fa-square-minus',
    checkboxOff: 'fal fa-square',
    checkboxOn: 'fal fa-check-square',
    next: 'fal fa-chevron-right',
    prev: 'fal fa-chevron-left',
    scrollChevron: 'fal fa-chevron-down',
    scrollChevronSolid: 'fas fa-chevron-down',
    dropdown: 'fas fa-caret-down',
    radioOff: 'fal fa-circle',
    radioOn: 'fas fa-dot-circle',
    file: 'fal fa-upload',
};

export const vuetify = createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: 'dark',
    },
    icons: {
        defaultSet: 'fa',
        aliases: customAliases,
        sets: {
            fa
        }
    }
});
